import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import BasicLayout from "@/layout/BasicLayout.vue";
import Index from "@/views/index.vue";

/* Router Modules */
import consoleRouter from "./modules/console";
import dncRouter from "./modules/dnc";
import jobRouter from "./modules/job";
import mdcRouter from "./modules/mdc";
import extranetRouter from "./modules/extranet";
import {materialRouter} from "./modules/material";
import tpmRouter from "./modules/tpm";
import qcRouter from "./modules/qc";
import opsRouter from "./modules/ops";
import andonRouter from "./modules/andon";

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
    permission: '['Platform.setting']' 如果不设置则默认有权限，设置了但是没命中就不会显示
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
const constantTempRoutes = [
  {
    path: "/",
    component: Index,
    children: [
      {
        path: "",
        component: () => import("../views/index.vue"),
        name: "home",
      },
    ],
  },
  {
    path: "/redirect",
    component: BasicLayout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path*",
        component: () => import("../views/redirect/index.vue"),
      },
    ],
  },
  {
    path: "/printDevice",
    component: () =>
      import("../views/console/devices-management/viewtab"),
    hidden: true,
  },
  {
    path: "/printCodeRules",
    component: () =>
      import("../views/print/index.vue"),
    hidden: true,
  },
  {
    path: "/login",
    component: () => import("../views/login/index.vue"),
    hidden: true,
  },
  {
    path: "/404",
    component: () => import("../views/exception/404.vue"),
    hidden: true,
  },
  {
    path: '/ops/pdfPoint',
    component: () => import('@/views/ops/point/workList.vue')
  },
  {
    path: "/job/point",
    component: () =>
    import("../views/job/point/point.vue"),
    hidden: true,
  },
  {
    path: "/deLivery/point",
    component: () =>
    import("../views/job/point/deLiveryPoint.vue"),
    hidden: true,
  },
  {
    path: "/material/point",
    component: () =>
    import("../views/material/point/point.vue"),
    hidden: true,
  },
  {
    path: "/huawei/imc",
    component: () => import("../views/huaweiImc/index.vue"),
    hidden: true,
  },
  {
    path: '/material',
    component: BasicLayout,
    children: materialRouter
  },
  {
    path: '/material/basics/statisticalReport',
    component: BasicLayout,
    children: [
      {
        path: '/material/basics/statisticalReport/stock',
        name: 'page_meterial_inventory_tatistics',
        component: () => import('../views/material/statistical-report/index'),
      },
      {
        path: '/material/basics/statisticalReport/record',
        name: 'page_meterial_analysis_setting',
        component: () => import('../views/material/statistical-report/index')
      }
    ]
  },
  {
    path: '/material/basics',
    component: BasicLayout,
    children: [{
      path: '/material/basics/delivery-plan',
      name: 'page_delivery_plan',
      component: () => import('../views/material/delivery-plan/index.vue'),
    }]
  },
]
console.log('cons', constantTempRoutes)
export const constantRoutes = constantTempRoutes
export const asyncRoutes = [dncRouter, consoleRouter, jobRouter, mdcRouter, extranetRouter, tpmRouter,qcRouter, opsRouter, andonRouter];
const createRouter = () =>
  new Router({
    mode: "history",
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes: constantRoutes,
  });

const router: any = createRouter();

export function resetRouter() {
  const newRouter: any = createRouter();
  router.matcher = newRouter.matcher;
}

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
} as any
export default router;
